import { render, staticRenderFns } from "./orgManage.vue?vue&type=template&id=4bb73bc4&scoped=true"
import script from "./orgManage.vue?vue&type=script&lang=js"
export * from "./orgManage.vue?vue&type=script&lang=js"
import style0 from "./orgManage.vue?vue&type=style&index=0&id=4bb73bc4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bb73bc4",
  null
  
)

export default component.exports